module.exports = __webpack_public_path__ + "static/stamp-c9ca13392baf75e00dc68b5d95974386.png";